import { icon } from '@fortawesome/fontawesome-svg-core'
import { faHeart } from '@fortawesome/free-solid-svg-icons'

const styles = { stroke: '#fff', 'stroke-width': '20' }
const heartIcon = icon(faHeart, { styles }).html[0]

const createHeart = (x, y, color) => {
  x = parseFloat(x || window.innerWidth - 50)
  y = parseFloat(y || window.innerHeight - 30)
  color = color || `hsl(${Math.floor(Math.random() * 360)}, 50%, 50% )`

  let phase = Math.random() * 360
  let radius = Math.random() * 1
  let speed = 1 + Math.random() * 2
  let rotate = Math.cos(phase / 50) * radius * 15
  let scale = 0.5
  let alpha = 1

  let outer = document.createElement('div')
  outer.style.pointerEvents = 'none'
  outer.style.position = 'absolute'
  outer.style.top = 0
  // Anchor to the physical left explicitly. Without this, an absolute
  // element under <body dir="rtl"> (v7 in Arabic) is placed against
  // the right edge by default, and translate3d(rect.left, ...) below
  // pushes it off-screen instead of into the viewport.
  outer.style.left = 0
  outer.style.zIndex = 1
  outer.style.color = color

  outer.innerHTML = heartIcon
  document.body.appendChild(outer)

  const draw = () => {
    outer.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${scale}) rotate(${rotate}deg)`
    outer.style.opacity = alpha
  }

  const flush = () => {
    document.body.removeChild(outer)
    outer = null
  }

  const update = () => {
    alpha = alpha - 0.005

    rotate = Math.cos(phase / 50) * radius * 15
    x += Math.cos(phase / 50) * radius
    y -= speed

    scale = Math.min(1.5, scale + 0.015)
    phase += 1

    if (y < -100 || alpha <= 0) {
      flush()
      return false
    } else {
      draw()
      return true
    }
  }

  draw()
  return { update }
}

let hearts = []

const loop = () => {
  hearts = hearts.filter(heart => heart.update())

  if (hearts.length)
    requestAnimationFrame(loop)
}

export const addHearts = ({ count, left, top, color }) => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return

  const loopRunning = hearts.length

  for (let i = 0; i < count; i++) {
    hearts.push(createHeart(left, top, color))
  }

  if (!loopRunning)
    requestAnimationFrame(loop)
}
